import { useQuery } from "@tanstack/react-query";
import smsPlaceHolderService from "..";

const useGetSmsDiscountPlaceHolder = () =>
  useQuery({
    queryKey: ["getSmsDiscountPlaceHolder"],
    queryFn: () => smsPlaceHolderService.getSmsPlaceHolders(),
    select: (res) => res,
  });

export { useGetSmsDiscountPlaceHolder };
